
// You can write more code here

/* START OF COMPILED CODE */

import Powerup from "../../game/powerups/Powerup";
/* START-USER-IMPORTS */
import Sprite = Phaser.GameObjects.Sprite;
import Tile from "../../game/Tile";
import { Sounds } from "../../sounds";
/* END-USER-IMPORTS */

export default class YosemiteSamPowerup extends Powerup {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // firable
    const firable = scene.add.image(0, 0, "game-tiles", "sam-bullet.png");
    firable.angle = -90;
    this.add(firable);

    this.firable = firable;

    /* START-USER-CTR-CODE */
    this.firable.visible = false;
    /* END-USER-CTR-CODE */
  }

  private firable: Phaser.GameObjects.Image;

  /* START-USER-CODE */

  public duration:number = 1000;
  public fireDuration:number = 120;
  public startOffset:number = 100;
  public fadeInDuration:number = 100;
  public movementDuration:number = 500;
  private fireTime:number = 0;
  private firableItems:Phaser.GameObjects.Sprite[] = [];
  private targettedTiles: Tile[] = [];
  update(playerX: number, playerY: number, time: number, deltaTime: number) {
    super.update(playerX, playerY, time, deltaTime);

    if(this.fireTime < 0)
    {
      this.fire();
      this.fireTime = this.fireDuration;
    }
    this.fireTime -= deltaTime;
  }

  fire()
  {
    if(!this.hasDestroyed) {

      let tile: Tile = this.levelManager.randomTile();
      if (this.targettedTiles.indexOf(tile) == -1) {
        if(tile != undefined)
        {
          let x = tile.x;//Phaser.Math.Between(this.levelManager.mapLeftBorder,this.levelManager.mapRightBorder);
          let y = tile.y;//Phaser.Math.Between(this.levelManager.mapTopBorder,this.levelManager.mapBottomBorder);

          this.scene.app.AudioHandler.playSound(this.scene, Sounds.Track.Bullet, Sounds.Channel.SFX, {
            volume: 0.8
          });

          let endY = y;
          y -= this.startOffset;
          let firableClone: Sprite = this.scene.add.sprite(x, y, this.firable.texture.key, this.firable.frame.name);
          firableClone.angle = -90;
          firableClone.scale = 0.6;

          firableClone.alpha = 0;

          this.scene.tweens.add({
            targets: firableClone,
            props: {
              alpha: {value: 1, duration: this.fadeInDuration},
            },
            ease: 'Quad.out'
          });

          let tween = this.scene.tweens.add({
            targets: firableClone,
            props: {
              y: {value: endY, duration: this.movementDuration},
            },
            ease: 'Quad.in'
          });

          this.firableItems.push(firableClone);

          tween.on('complete', () => {
            let size = firableClone.width;
            if (this.levelManager.hitObject(x, endY, size, x, endY)) {
            }
            firableClone.destroy(true);
          });


          console.log("Firing item", firableClone.x, firableClone.y);
          this.targettedTiles.push(tile);
        }
      }
    }
  }

  EndPowerup() {
    super.EndPowerup();
    // for(let i = 0; i < this.firableItems.length; ++i)
    // {
    //   this.firableItems[i].destroy(true);
    // }
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
